import { AEMOptions } from "@AEM/models/AEMPage.model"
import { AEMPageType } from "@AEM/models/AEMPage.model"
import { UseQueryResult } from "@tanstack/react-query"
import { useAEMContent } from "./useAEMContent"
import { AEMFooter } from "@AEM/models/AEMResponse.model"
import { createItemsArrayMapper } from "@AEM/AEMContentMapper"

export const useAEMFooterData = (options?: AEMOptions) => {
	const { data, isLoading, error, refetch } = useAEMContent(
		AEMPageType.FOOTER,
		{ ...options, mapper: createItemsArrayMapper() }
	) as UseQueryResult<AEMFooter[]>

	const footerData = data?.[0] ?? ({} as AEMFooter)

	return { footerData, isLoading, error, refetch }
}
